export const restaurantsPath = '/restaurants';
export const getRestaurants = restaurantsPath;
export const getRestaurantById = (id: number) => `${restaurantsPath}/${id}`;
export const createRestaurant = restaurantsPath;
export const updateRestaurant = (id: number) => `${restaurantsPath}/${id}`;
export const updateRestaurantStatus = (id: number) => `${restaurantsPath}/${id}/activation`;
export const uploadMenuXlsx = (restaurantId: number) => `${restaurantsPath}/${restaurantId}/bulk`;
export const uploadMenuImages = (restaurantId: number) => `${restaurantsPath}/${restaurantId}/image/bulk`;
export const restaurantImagesSync = `${restaurantsPath}/image/sync`;